<template>
	<div class="multistep-wizard-form">
		<div
			class="multistep-wizard-form-steps"
			id="multistep-wizard-form-steps">
			<b-button
				class="btn-steps-overview-toggle d-block d-md-none"
				v-b-toggle.multistep-wizard-form-steps-toggle
				variant="primary">
				<i class="form-icon far fa-tasks"></i><span class="steps-toggle-label">Voortgang</span>
			</b-button>
			<b-collapse
				class="multistep-wizard-form-toggleable-content"
				id="multistep-wizard-form-steps-toggle"
				v-model="visible">
				<ul class="form-steps">
					<li
						class="form-step"
						v-for="(step, needle) in steps"
						:data-step="step.step_number"
						:class="getStatusClassName(step)">
						<span class="step-count">{{ needle + 1 }}</span>
						<span class="step-title">{{ step.title }}</span>
						<i class="icon far fa-check"></i>
					</li>
				</ul>
			</b-collapse>
		</div>
		<div class="multistep-wizard-form-step-content">
			<slot :name="'step-' + (index + 1)"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'design-2021-apprentice-multistep-form-wizard-form-component',
		props: {
			steps: {
				type: Array,
				required: true,
			},

			index: {
				type: Number,
				required: false,
			},

			currentStep: {
				type: Number,
				required: true,
			},
		},
		data() {
			return {
				windowWidth: 0,
				visible: true,
			};
		},

		created() {
			window.addEventListener('resize', this.handleResize);
			this.handleResize();
		},

		destroyed() {
			window.removeEventListener('resize', this.handleResize);
		},

		computed: {
			step() {
				if (this.currentStep === null) {
					return {};
				}

				return this.steps.filter((step) => step.step_number === this.currentStep);
			},
		},

		methods: {
			handleResize() {
				this.windowWidth = window.innerWidth;
				this.visible = this.windowWidth > 767;
			},

			getStatusClassName(step) {
				if (step.step_number === this.currentStep - 1) {
					return 'isCompleted';
				} else if (step.step_number < this.currentStep) {
					return 'done';
				} else if (step.step_number === this.currentStep) {
					return 'active';
				}
			},
		},
	};
</script>

<style scoped lang="scss">
	@keyframes strike {
		0% {
			width: 0;
		}
		100% {
			width: 110%;
		}
	}

	@keyframes visibility {
		0% {
			opacity: 0;
			color: transparent;
		}
		100% {
			opacity: 1;
			color: $primary;
		}
	}

	.multistep-wizard-form {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
	}

	.multistep-wizard-form-steps {
		margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
	}

	.btn-steps-overview-toggle {
		width: 100%;

		.form-icon {
			margin-right: map-get($grid-gutter-spacing, 'eight');
		}
	}

	.multistep-wizard-form-toggleable-content {
		padding: map-get($grid-gutter-spacing, 'fifteen');
	}

	.form-steps {
		list-style: none;
		padding: 0;
	}

	.form-step {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		column-gap: map-get($grid-gutter-spacing, 'twenty-one');
		margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
		text-decoration: none;
		transition: 0.5s;

		&.active {
			font-size: 1.125rem;
			font-weight: $font-weight-bold;
		}

		&.done,
		&.isCompleted {
			.step-title {
				font-weight: $font-weight-bold;

				&:after {
					content: '';
					position: absolute;
					top: 50%;
					right: -4px;
					width: 110%;
					height: 3px;
					background: $primary;
				}
			}

			.icon {
				opacity: 1;
				color: $primary;
			}
		}

		&.isCompleted {
			.step-title:after {
				animation-name: strike;
				animation-duration: 0.5s;
				animation-timing-function: linear;
				animation-iteration-count: 1;
				animation-fill-mode: forwards;
			}

			.icon {
				animation-name: visibility;
				animation-duration: 0.5s;
				animation-timing-function: linear;
				animation-iteration-count: 1;
				animation-fill-mode: forwards;
			}
		}
	}

	.step-count {
		width: 35px;
		height: 35px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		background-color: $primary;
		color: $white;
		font-weight: $font-weight-bold;
		font-size: 1.125rem;
	}

	.step-title {
		color: $text-muted-color;
		position: relative;
	}

	.icon {
		opacity: 0;
		color: transparent;
		transition: 2s;
		font-size: 1.3125rem;
	}

	::v-deep .multistep-wizard-form-step-content {
		h3.title {
			& + .description {
				line-height: 1.5;
				font-size: $base-font-size;
				font-weight: $font-weight-medium;
				color: $text-muted-color;
				margin-bottom: $grid-gutter-width;
			}
		}
	}

	@media (min-width: map-get($grid-breakpoints, 'md')) {
		.multistep-wizard-form {
			flex-direction: row;
			column-gap: $grid-gutter-width;
		}

		.multistep-wizard-form-steps {
			flex: 0 1 25%;
			padding-right: map-get($grid-gutter-spacing, 'fifteen');
		}

		.multistep-wizard-form-step-content {
			flex: 0 1 75%;
		}
	}

	@media (min-width: map-get($grid-breakpoints, 'xl')) {
		.multistep-wizard-form {
			column-gap: map-get($grid-gutter-spacing, 'sixty');
		}
	}
</style>
